var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4951 32.1453L33.7793 11.861L30.9509 9.03252L10.6667 29.3169V32.1453H13.4951ZM15.1519 36.1453H6.66666V27.6599L29.5367 4.78988C30.3179 4.00884 31.5841 4.00884 32.3651 4.78988L38.0221 10.4467C38.8031 11.2278 38.8031 12.4941 38.0221 13.2752L15.1519 36.1453ZM6.66666 40.1453H42.6667V44.1453H6.66666V40.1453Z",
    fill: "#3940A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.8f140c1dc03ae9bd91d39aae7c49779d.svg";
export { ForwardRef as ReactComponent };